// @flow
import type { Action } from "../action";

type State = boolean;

function setState(state, payload: Object) {
  if (payload.op === "phone-confirm-call") {
    return payload.result ? false : true;
  }

  return state;
}

function phoneCallVerification(state: State = false, action: Action): State {
  switch (action.type) {
    case "CLEAR_PHONE_CALL_VERIFICATION":
      return false;
    case "SET_PHONE_CALL":
      return true;
    case "RECEIVE_SOCKET_MESSAGE":
      return setState(state, action.payload);
    default:
      return state;
  }
}

export default phoneCallVerification;



// WEBPACK FOOTER //
// ./src/redux/reducer/phoneCallVerification.js